import type {
  BackendModule,
  Services,
  InitOptions,
  ReadCallback,
} from 'i18next';

import { getTranslations, mapToApiCode } from '.';

interface BackendOptions {
  group?: string;
}

interface ApiBackendType extends BackendModule<BackendOptions> {
  type: 'backend';
  options?: BackendOptions;
  services?: Services;
}

/**
 * Backend customizado para i18next que carrega traduções da API
 */
const ApiBackend: ApiBackendType = {
  type: 'backend',
  options: {},
  services: undefined,

  init(
    services: Services,
    backendOptions: BackendOptions,
    _i18nextOptions: InitOptions,
  ): void {
    this.services = services;
    this.options = backendOptions || {};
  },

  read(language: string, _namespace: string, callback: ReadCallback): void {
    const group = this.options?.group || 'play';
    const apiCode = mapToApiCode(language);

    getTranslations(apiCode, group)
      .then((translations) => {
        callback(null, translations);
      })
      .catch((error) => {
        console.error(`Falha ao carregar traduções para ${language}:`, error);
        // Retornar objeto vazio para não quebrar a aplicação
        callback(null, {});
      });
  },
};

export default ApiBackend;
